import { useEffect } from 'react';
import { ref, onValue, set, onDisconnect, off, increment } from "firebase/database";
import { realtimeDatabase } from '../database/firebase'; // Using Realtime Database instead of Firestore

const UseHandleConnection = ({ userId, sessionId, themeId }) => {
  useEffect(() => {
    if (!userId || !sessionId || !themeId) return; // Ensure all necessary IDs are available

    // References for the live counter
    const connectedRef = ref(realtimeDatabase, ".info/connected");
    const themeSessionRef = ref(realtimeDatabase, `sessions/${sessionId}/${themeId}/counter`);

    const connectedListener = onValue(connectedRef, (snapshot) => {
      if (snapshot.val() === true) {
        // Increment the counter when the user connects
        set(themeSessionRef, increment(1));

        // Decrement the counter when the user disconnects
        onDisconnect(themeSessionRef).set(increment(-1));
      }
    });

    // Cleanup listener on component unmount
    return () => {
      off(connectedRef, 'value', connectedListener);
    };
  }, [userId, sessionId, themeId]);

  return null;
};

export default UseHandleConnection;
